import btnManagement from './button-managment.js';

export default function updateDisplayNumber(settings) {
	const rootEl = settings.rootEl;
	if (rootEl instanceof window.HTMLElement) {
		const showingEl = rootEl.querySelector(
			'p.load-more-button-width-display-number__results-count span.showing'
		);
		const totalEL = rootEl.querySelector(
			'p.load-more-button-width-display-number__results-count span.total'
		);
		if (
			showingEl instanceof window.HTMLElement &&
			totalEL instanceof window.HTMLElement
		) {
			const increment = showingEl.dataset.init;
			const total = totalEL.textContent;
			const postNumber =
				parseInt(showingEl.textContent) + parseInt(increment);
			if (postNumber > total) {
				showingEl.textContent = total;
				if (settings.button instanceof window.HTMLElement) {
					btnManagement(settings.button, 'hide');
				}
			} else {
				showingEl.textContent = postNumber;
				if (settings.button instanceof window.HTMLElement) {
					btnManagement(settings.button, 'show');
				}
			}
		}
	}
}
